const cashFlowCopy={
  "es": {
    "CONTROL FINANCIERO": "CONTROL FINANCIERO",
    "Flujo de Caja": "Flujo de Caja",
    "Cada movimiento, una visión más clara.": "Cada movimiento, una visión más clara.",
    "Revisemos juntos tus ingresos, gastos y movimientos pendientes de fecha.": "Revisemos juntos tus ingresos, gastos y movimientos pendientes de fecha.",
    "Compara tus ingresos y gastos, elige un período y consulta los valores exactos en cada gráfico.": "Compara tus ingresos y gastos, elige un período y consulta los valores exactos en cada gráfico.",
    "Filtros de flujo de caja": "Filtros de flujo de caja",
    "TU PERÍODO, A TU MEDIDA": "TU PERÍODO, A TU MEDIDA",
    "Explora tu flujo": "Explora tu flujo",
    "Actualizar datos": "Actualizar datos",
    "Actualizar": "Actualizar",
    "Exportar": "Exportar",
    "Exportar CSV": "Exportar CSV",
    "Período de análisis": "Período de análisis",
    "Semana": "Semana",
    "Mes": "Mes",
    "Año": "Año",
    "Personalizado": "Personalizado",
    "Mes anterior": "Mes anterior",
    "Mes siguiente": "Mes siguiente",
    "Mes actual": "Mes actual",
    "Desde": "Desde",
    "Hasta": "Hasta",
    "Fecha inicial": "Fecha inicial",
    "Fecha final": "Fecha final",
    "Selecciona un rango de fechas válido.": "Selecciona un rango de fechas válido.",
    "Elige un período de hasta 366 días.": "Elige un período de hasta 366 días.",
    "Actualizando datos…": "Actualizando datos…",
    "Actualizado": "Actualizado",
    "Preparando tu flujo de caja…": "Preparando tu flujo de caja…",
    "Ingresos Totales": "Ingresos Totales",
    "Ventas + otros ingresos": "Ventas + otros ingresos",
    "Gastos Totales": "Gastos Totales",
    "Egresos del período": "Egresos del período",
    "Balance Neto": "Balance Neto",
    "Flujo positivo": "Flujo positivo",
    "Flujo negativo": "Flujo negativo",
    "BRIEFY · Tu panorama": "BRIEFY · Tu panorama",
    "Tus ingresos cubren los gastos de este período.": "Tus ingresos cubren los gastos de este período.",
    "Tus gastos superan los ingresos de este período.": "Tus gastos superan los ingresos de este período.",
    "Consultar a BRIEFY": "Consultar a BRIEFY",
    "No hay movimientos registrados en este período.": "No hay movimientos registrados en este período.",
    "DE LOS NÚMEROS A LAS DECISIONES": "DE LOS NÚMEROS A LAS DECISIONES",
    "El ritmo de tu dinero": "El ritmo de tu dinero",
    "Compara entradas, salidas y balance con una misma escala.": "Compara entradas, salidas y balance con una misma escala.",
    "Solo días con actividad": "Solo días con actividad",
    "Movimientos diarios": "Movimientos diarios",
    "Ingresos y gastos con una misma escala. Consulta los importes exactos en la tabla.": "Ingresos y gastos con una misma escala. Consulta los importes exactos en la tabla.",
    "Fecha por revisar": "Fecha por revisar",
    "Ingresos": "Ingresos",
    "Gastos": "Gastos",
    "Balance por día": "Balance por día",
    "Un balance por debajo de cero indica que ese día los gastos superaron los ingresos.": "Un balance por debajo de cero indica que ese día los gastos superaron los ingresos.",
    "Balance neto": "Balance neto",
    "Los movimientos sin fecha válida están incluidos en los totales y en “Fecha por revisar”.": "Los movimientos sin fecha válida están incluidos en los totales y en “Fecha por revisar”.",
    "RESUMEN DEL PERÍODO": "RESUMEN DEL PERÍODO",
    "Resumen del Flujo": "Resumen del Flujo",
    "Días con saldo positivo": "Días con saldo positivo",
    "Días con saldo negativo": "Días con saldo negativo",
    "Promedio Diario": "Promedio Diario",
    "Mejor Día": "Mejor Día",
    "El resumen diario usa únicamente los movimientos con fecha asignada. El CSV incluye todo el período.": "El resumen diario usa únicamente los movimientos con fecha asignada. El CSV incluye todo el período.",
    "Período": "Período",
    "Fecha": "Fecha",
    "TOTAL": "TOTAL",
    "flujo_caja": "flujo_caja"
  },
  "en": {
    "CONTROL FINANCIERO": "FINANCIAL CONTROL",
    "Flujo de Caja": "Cash Flow",
    "Cada movimiento, una visión más clara.": "Every transaction, a clearer picture.",
    "Revisemos juntos tus ingresos, gastos y movimientos pendientes de fecha.": "Let’s review income, expenses and transactions awaiting a date.",
    "Compara tus ingresos y gastos, elige un período y consulta los valores exactos en cada gráfico.": "Compare income and expenses, choose a period and view exact values in each chart.",
    "Filtros de flujo de caja": "Cash Flow Filters",
    "TU PERÍODO, A TU MEDIDA": "YOUR PERIOD, YOUR PERSPECTIVE",
    "Explora tu flujo": "Explore Your Cash Flow",
    "Actualizar datos": "Refresh Data",
    "Actualizar": "Refresh",
    "Exportar": "Export",
    "Exportar CSV": "Export CSV",
    "Período de análisis": "Analysis Period",
    "Semana": "Week",
    "Mes": "Month",
    "Año": "Year",
    "Personalizado": "Custom",
    "Mes anterior": "Previous Month",
    "Mes siguiente": "Next Month",
    "Mes actual": "Current Month",
    "Desde": "From",
    "Hasta": "To",
    "Fecha inicial": "Start Date",
    "Fecha final": "End Date",
    "Selecciona un rango de fechas válido.": "Select a valid date range.",
    "Elige un período de hasta 366 días.": "Choose a period of up to 366 days.",
    "Actualizando datos…": "Refreshing Data…",
    "Actualizado": "Updated",
    "Preparando tu flujo de caja…": "Preparing Your Cash Flow…",
    "Ingresos Totales": "Total Income",
    "Ventas + otros ingresos": "Sales + Other Income",
    "Gastos Totales": "Total Expenses",
    "Egresos del período": "Expenses for the Period",
    "Balance Neto": "Net Balance",
    "Flujo positivo": "Positive Cash Flow",
    "Flujo negativo": "Negative Cash Flow",
    "BRIEFY · Tu panorama": "BRIEFY · Your Overview",
    "Tus ingresos cubren los gastos de este período.": "Your income covers expenses for this period.",
    "Tus gastos superan los ingresos de este período.": "Your expenses exceed income for this period.",
    "Consultar a BRIEFY": "Ask BRIEFY",
    "No hay movimientos registrados en este período.": "No transactions recorded in this period.",
    "DE LOS NÚMEROS A LAS DECISIONES": "FROM NUMBERS TO DECISIONS",
    "El ritmo de tu dinero": "The Rhythm of Your Cash Flow",
    "Compara entradas, salidas y balance con una misma escala.": "Compare inflows, outflows and balance on a shared scale.",
    "Solo días con actividad": "Only Days with Activity",
    "Movimientos diarios": "Daily Transactions",
    "Ingresos y gastos con una misma escala. Consulta los importes exactos en la tabla.": "Income and expenses on a shared scale. View exact amounts in the table.",
    "Fecha por revisar": "Date to Review",
    "Ingresos": "Income",
    "Gastos": "Expenses",
    "Balance por día": "Daily Balance",
    "Un balance por debajo de cero indica que ese día los gastos superaron los ingresos.": "A balance below zero means expenses exceeded income that day.",
    "Balance neto": "Net Balance",
    "Los movimientos sin fecha válida están incluidos en los totales y en “Fecha por revisar”.": "Transactions without a valid date are included in totals and under “Date to Review”.",
    "RESUMEN DEL PERÍODO": "PERIOD OVERVIEW",
    "Resumen del Flujo": "Cash Flow Summary",
    "Días con saldo positivo": "Days with a Positive Balance",
    "Días con saldo negativo": "Days with a Negative Balance",
    "Promedio Diario": "Daily Average",
    "Mejor Día": "Best Day",
    "El resumen diario usa únicamente los movimientos con fecha asignada. El CSV incluye todo el período.": "The daily summary uses only transactions with an assigned date. The CSV includes the full period.",
    "Período": "Period",
    "Fecha": "Date",
    "TOTAL": "TOTAL",
    "flujo_caja": "cash_flow"
  },
  "pt": {
    "CONTROL FINANCIERO": "CONTROLE FINANCEIRO",
    "Flujo de Caja": "Fluxo de caixa",
    "Cada movimiento, una visión más clara.": "Cada movimento, uma visão mais clara.",
    "Revisemos juntos tus ingresos, gastos y movimientos pendientes de fecha.": "Vamos revisar receitas, despesas e movimentos sem data válida.",
    "Compara tus ingresos y gastos, elige un período y consulta los valores exactos en cada gráfico.": "Compare receitas e despesas, escolha um período e consulte os valores exatos em cada gráfico.",
    "Filtros de flujo de caja": "Filtros de fluxo de caixa",
    "TU PERÍODO, A TU MEDIDA": "SEU PERÍODO, SUA VISÃO",
    "Explora tu flujo": "Explore seu fluxo",
    "Actualizar datos": "Atualizar dados",
    "Actualizar": "Atualizar",
    "Exportar": "Exportar",
    "Exportar CSV": "Exportar CSV",
    "Período de análisis": "Período de análise",
    "Semana": "Semana",
    "Mes": "Mês",
    "Año": "Ano",
    "Personalizado": "Personalizado",
    "Mes anterior": "Mês anterior",
    "Mes siguiente": "Próximo mês",
    "Mes actual": "Mês atual",
    "Desde": "De",
    "Hasta": "Até",
    "Fecha inicial": "Data inicial",
    "Fecha final": "Data final",
    "Selecciona un rango de fechas válido.": "Selecione um intervalo de datas válido.",
    "Elige un período de hasta 366 días.": "Escolha um período de até 366 dias.",
    "Actualizando datos…": "Atualizando dados…",
    "Actualizado": "Atualizado",
    "Preparando tu flujo de caja…": "Preparando seu fluxo de caixa…",
    "Ingresos Totales": "Receitas totais",
    "Ventas + otros ingresos": "Vendas + outras receitas",
    "Gastos Totales": "Despesas totais",
    "Egresos del período": "Despesas do período",
    "Balance Neto": "Saldo líquido",
    "Flujo positivo": "Fluxo positivo",
    "Flujo negativo": "Fluxo negativo",
    "BRIEFY · Tu panorama": "BRIEFY · Seu panorama",
    "Tus ingresos cubren los gastos de este período.": "Suas receitas cobrem as despesas deste período.",
    "Tus gastos superan los ingresos de este período.": "Suas despesas superam as receitas deste período.",
    "Consultar a BRIEFY": "Consultar o BRIEFY",
    "No hay movimientos registrados en este período.": "Não há movimentos registrados neste período.",
    "DE LOS NÚMEROS A LAS DECISIONES": "DOS NÚMEROS ÀS DECISÕES",
    "El ritmo de tu dinero": "O ritmo do seu dinheiro",
    "Compara entradas, salidas y balance con una misma escala.": "Compare entradas, saídas e saldo na mesma escala.",
    "Solo días con actividad": "Apenas dias com atividade",
    "Movimientos diarios": "Movimentos diários",
    "Ingresos y gastos con una misma escala. Consulta los importes exactos en la tabla.": "Receitas e despesas na mesma escala. Consulte os valores exatos na tabela.",
    "Fecha por revisar": "Data a revisar",
    "Ingresos": "Receitas",
    "Gastos": "Despesas",
    "Balance por día": "Saldo diário",
    "Un balance por debajo de cero indica que ese día los gastos superaron los ingresos.": "Um saldo abaixo de zero indica que as despesas superaram as receitas naquele dia.",
    "Balance neto": "Saldo líquido",
    "Los movimientos sin fecha válida están incluidos en los totales y en “Fecha por revisar”.": "Movimentos sem data válida estão incluídos nos totais e em “Data a revisar”.",
    "RESUMEN DEL PERÍODO": "RESUMO DO PERÍODO",
    "Resumen del Flujo": "Resumo do fluxo",
    "Días con saldo positivo": "Dias com saldo positivo",
    "Días con saldo negativo": "Dias com saldo negativo",
    "Promedio Diario": "Média diária",
    "Mejor Día": "Melhor dia",
    "El resumen diario usa únicamente los movimientos con fecha asignada. El CSV incluye todo el período.": "O resumo diário usa apenas movimentos com data atribuída. O CSV inclui todo o período.",
    "Período": "Período",
    "Fecha": "Data",
    "TOTAL": "TOTAL",
    "flujo_caja": "fluxo_caixa"
  },
  "fr": {
    "CONTROL FINANCIERO": "PILOTAGE FINANCIER",
    "Flujo de Caja": "Flux de trésorerie",
    "Cada movimiento, una visión más clara.": "Chaque opération, une vision plus claire.",
    "Revisemos juntos tus ingresos, gastos y movimientos pendientes de fecha.": "Examinons les revenus, dépenses et opérations dont la date reste à vérifier.",
    "Compara tus ingresos y gastos, elige un período y consulta los valores exactos en cada gráfico.": "Comparez revenus et dépenses, choisissez une période et consultez les montants exacts dans chaque graphique.",
    "Filtros de flujo de caja": "Filtres de trésorerie",
    "TU PERÍODO, A TU MEDIDA": "VOTRE PÉRIODE, VOTRE PERSPECTIVE",
    "Explora tu flujo": "Explorez votre trésorerie",
    "Actualizar datos": "Actualiser les données",
    "Actualizar": "Actualiser",
    "Exportar": "Exporter",
    "Exportar CSV": "Exporter en CSV",
    "Período de análisis": "Période d’analyse",
    "Semana": "Semaine",
    "Mes": "Mois",
    "Año": "Année",
    "Personalizado": "Personnalisé",
    "Mes anterior": "Mois précédent",
    "Mes siguiente": "Mois suivant",
    "Mes actual": "Mois en cours",
    "Desde": "Du",
    "Hasta": "Au",
    "Fecha inicial": "Date de début",
    "Fecha final": "Date de fin",
    "Selecciona un rango de fechas válido.": "Sélectionnez une période valide.",
    "Elige un período de hasta 366 días.": "Choisissez une période de 366 jours maximum.",
    "Actualizando datos…": "Actualisation des données…",
    "Actualizado": "Mis à jour",
    "Preparando tu flujo de caja…": "Préparation de votre trésorerie…",
    "Ingresos Totales": "Total des revenus",
    "Ventas + otros ingresos": "Ventes + autres revenus",
    "Gastos Totales": "Total des dépenses",
    "Egresos del período": "Dépenses de la période",
    "Balance Neto": "Solde net",
    "Flujo positivo": "Flux positif",
    "Flujo negativo": "Flux négatif",
    "BRIEFY · Tu panorama": "BRIEFY · Votre aperçu",
    "Tus ingresos cubren los gastos de este período.": "Vos revenus couvrent les dépenses de cette période.",
    "Tus gastos superan los ingresos de este período.": "Vos dépenses dépassent les revenus de cette période.",
    "Consultar a BRIEFY": "Consulter BRIEFY",
    "No hay movimientos registrados en este período.": "Aucune opération enregistrée sur cette période.",
    "DE LOS NÚMEROS A LAS DECISIONES": "DES CHIFFRES AUX DÉCISIONS",
    "El ritmo de tu dinero": "Le rythme de votre trésorerie",
    "Compara entradas, salidas y balance con una misma escala.": "Comparez entrées, sorties et solde sur une même échelle.",
    "Solo días con actividad": "Uniquement les jours avec activité",
    "Movimientos diarios": "Opérations quotidiennes",
    "Ingresos y gastos con una misma escala. Consulta los importes exactos en la tabla.": "Revenus et dépenses sur une même échelle. Consultez les montants exacts dans le tableau.",
    "Fecha por revisar": "Date à vérifier",
    "Ingresos": "Revenus",
    "Gastos": "Dépenses",
    "Balance por día": "Solde quotidien",
    "Un balance por debajo de cero indica que ese día los gastos superaron los ingresos.": "Un solde inférieur à zéro signifie que les dépenses ont dépassé les revenus ce jour-là.",
    "Balance neto": "Solde net",
    "Los movimientos sin fecha válida están incluidos en los totales y en “Fecha por revisar”.": "Les opérations sans date valide sont incluses dans les totaux et sous « Date à vérifier ».",
    "RESUMEN DEL PERÍODO": "APERÇU DE LA PÉRIODE",
    "Resumen del Flujo": "Résumé de trésorerie",
    "Días con saldo positivo": "Jours à solde positif",
    "Días con saldo negativo": "Jours à solde négatif",
    "Promedio Diario": "Moyenne quotidienne",
    "Mejor Día": "Meilleur jour",
    "El resumen diario usa únicamente los movimientos con fecha asignada. El CSV incluye todo el período.": "Le résumé quotidien utilise uniquement les opérations datées. Le CSV inclut toute la période.",
    "Período": "Période",
    "Fecha": "Date",
    "TOTAL": "TOTAL",
    "flujo_caja": "flux_tresorerie"
  }
};
export default cashFlowCopy;
